<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px" align="center">
          <v-col cols="4">
            <h3>ميزان المراجعة - كشف الاقساط</h3>
          </v-col>
          <v-col cols="3">
            <v-select v-model="selectedSection" :items="sections" item-text="sectionName" item-value="sectionId" label="القسم" outlined dense hide-details clearable></v-select>
          </v-col>
          <v-col cols="2">
            <v-select v-model="selectedLevel" :items="levels" item-text="levelName" item-value="level" label="المرحلة" outlined dense hide-details clearable></v-select>
          </v-col>
          <v-col cols="3">
            <v-btn color="success" @click="exportToExcel" :loading="exporting" :disabled="filteredData.length === 0" block>
              <v-icon left>mdi-file-excel</v-icon>
              تصدير Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid v-if="filteredData.length > 0">
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="3">
            <h4>عدد الطلبة: {{ filteredData.length.toLocaleString("en-US") }}</h4>
          </v-col>
          <v-col cols="3">
            <h4>متبقي سابق: {{ sumPreviousRemaining.toLocaleString("en-US") }}</h4>
          </v-col>
          <v-col cols="3">
            <h4>اقساط حالية: {{ sumCurrentInstallment.toLocaleString("en-US") }}</h4>
          </v-col>
          <v-col cols="3">
            <h4 style="color: red; font-weight: 700">الاجمالي: {{ sumTotal.toLocaleString("en-US") }}</h4>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-card-title>
          <v-text-field v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="filteredData" :items-per-page="15" :search="search" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>

          <template v-slot:[`item.previousRemaining`]="{ item }">
            <p style="padding: 0 3px" :style="{ color: item.previousRemaining > 0 ? 'red' : '#0E734B', fontWeight: '600' }">{{ item.previousRemaining.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentRawFee`]="{ item }">
            <p style="padding: 0 3px">{{ item.currentRawFee.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentDiscountPercent`]="{ item }">
            <p style="padding: 0 3px">{{ item.currentDiscountPercent }}%</p>
          </template>

          <template v-slot:[`item.currentPercentageDiscountAmount`]="{ item }">
            <p style="padding: 0 3px">{{ item.currentPercentageDiscountAmount.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentFixedDiscount`]="{ item }">
            <p style="padding: 0 3px">{{ item.currentFixedDiscount.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentInstallment`]="{ item }">
            <p style="padding: 0 3px">{{ item.currentInstallment.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentPaid`]="{ item }">
            <p style="padding: 0 3px; color: #0e734b; font-weight: 600">{{ item.currentPaid.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.currentRemaining`]="{ item }">
            <p style="padding: 0 3px" :style="{ color: item.currentRemaining > 0 ? 'red' : '#0E734B', fontWeight: '600' }">{{ item.currentRemaining.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`item.total`]="{ item }">
            <p style="padding: 0 3px; color: red; font-weight: 700">{{ item.total.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`body.append`]>
            <tr style="background: #E8F5E9; font-weight: 700">
              <td colspan="6" style="text-align: center; padding: 8px">المجموع</td>
              <td style="padding: 8px">{{ sumPreviousRemaining.toLocaleString("en-US") }}</td>
              <td style="padding: 8px">{{ sumCurrentRawFee.toLocaleString("en-US") }}</td>
              <td style="padding: 8px"></td>
              <td style="padding: 8px">{{ sumPercentageDiscount.toLocaleString("en-US") }}</td>
              <td style="padding: 8px">{{ sumFixedDiscount.toLocaleString("en-US") }}</td>
              <td style="padding: 8px">{{ sumCurrentInstallment.toLocaleString("en-US") }}</td>
              <td style="padding: 8px">{{ sumCurrentPaid.toLocaleString("en-US") }}</td>
              <td style="padding: 8px">{{ sumCurrentRemaining.toLocaleString("en-US") }}</td>
              <td style="padding: 8px; color: red">{{ sumTotal.toLocaleString("en-US") }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "TrialBalance",
  data: () => ({
    overlay: false,
    exporting: false,
    search: "",
    students: [],
    selectedSection: null,
    selectedLevel: null,
    levels: [
      { levelName: "المرحلة الاولى", level: 1 },
      { levelName: "المرحلة الثانية", level: 2 },
      { levelName: "المرحلة الثالثة", level: 3 },
      { levelName: "المرحلة الرابعة", level: 4 },
      { levelName: "المرحلة الخامسة", level: 5 },
    ],
    headers: [
      { text: "ت", value: "index", width: 50 },
      { text: "اسم الطالب", value: "studentName" },
      { text: "الرقم الجامعي", value: "collegeNumber" },
      { text: "القسم", value: "sectionName" },
      { text: "المرحلة", value: "level", width: 70 },
      { text: "حالة الطالب", value: "statusName" },
      { text: "متبقي حتى 31/08/2025", value: "previousRemaining" },
      { text: "القسط بدون خصم", value: "currentRawFee" },
      { text: "نسبة الخصم %", value: "currentDiscountPercent", width: 100 },
      { text: "خصم النسبة", value: "currentPercentageDiscountAmount" },
      { text: "خصم ثابت", value: "currentFixedDiscount" },
      { text: "قسط السنة الحالية", value: "currentInstallment" },
      { text: "المدفوع الحالي", value: "currentPaid" },
      { text: "متبقي السنة الحالية", value: "currentRemaining" },
      { text: "الاجمالي", value: "total" },
    ],
  }),
  computed: {
    sections() {
      const sectionMap = {};
      this.students.forEach((s) => {
        if (!sectionMap[s.sectionName]) {
          sectionMap[s.sectionName] = { sectionName: s.sectionName, sectionId: s.sectionName };
        }
      });
      return Object.values(sectionMap);
    },
    filteredData() {
      return this.students.filter((s) => {
        if (this.selectedSection && s.sectionName !== this.selectedSection) return false;
        if (this.selectedLevel && s.level !== this.selectedLevel) return false;
        return true;
      });
    },
    sumPreviousRemaining() {
      return this.filteredData.reduce((sum, s) => sum + s.previousRemaining, 0);
    },
    sumCurrentRawFee() {
      return this.filteredData.reduce((sum, s) => sum + s.currentRawFee, 0);
    },
    sumPercentageDiscount() {
      return this.filteredData.reduce((sum, s) => sum + s.currentPercentageDiscountAmount, 0);
    },
    sumFixedDiscount() {
      return this.filteredData.reduce((sum, s) => sum + s.currentFixedDiscount, 0);
    },
    sumCurrentInstallment() {
      return this.filteredData.reduce((sum, s) => sum + s.currentInstallment, 0);
    },
    sumCurrentPaid() {
      return this.filteredData.reduce((sum, s) => sum + s.currentPaid, 0);
    },
    sumCurrentRemaining() {
      return this.filteredData.reduce((sum, s) => sum + s.currentRemaining, 0);
    },
    sumTotal() {
      return this.filteredData.reduce((sum, s) => sum + s.total, 0);
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let self = this;
      self.overlay = true;

      self.$http
        .get(`${self.$store.state.apiUrlFees}/getTrialBalanceReport`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          self.students = res.data.students.map((s) => ({
            ...s,
            previousRemaining: Number(s.previousRemaining) || 0,
            currentRawFee: Number(s.currentRawFee) || 0,
            currentDiscountPercent: Number(s.currentDiscountPercent) || 0,
            currentPercentageDiscountAmount: Number(s.currentPercentageDiscountAmount) || 0,
            currentFixedDiscount: Number(s.currentFixedDiscount) || 0,
            currentInstallment: Number(s.currentInstallment) || 0,
            currentPaid: Number(s.currentPaid) || 0,
            currentRemaining: Number(s.currentRemaining) || 0,
            total: Number(s.total) || 0,
            level: Number(s.level) || 0,
          }));
          self.overlay = false;
        })
        .catch((e) => {
          console.log(e);
          self.overlay = false;
          self.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
        });
    },
    async exportToExcel() {
      this.exporting = true;
      try {
        const exportData = this.filteredData.map((s, i) => ({
          ت: i + 1,
          "اسم الطالب": s.studentName,
          "الرقم الجامعي": s.collegeNumber,
          القسم: s.sectionName,
          المرحلة: s.level,
          "حالة الطالب": s.statusName,
          "متبقي حتى 31/08/2025": s.previousRemaining,
          "القسط بدون خصم": s.currentRawFee,
          "نسبة الخصم %": s.currentDiscountPercent,
          "خصم النسبة": s.currentPercentageDiscountAmount,
          "خصم ثابت": s.currentFixedDiscount,
          "قسط السنة الحالية": s.currentInstallment,
          "المدفوع الحالي": s.currentPaid,
          "متبقي السنة الحالية": s.currentRemaining,
          الاجمالي: s.total,
        }));

        const ExcelJS = await import("exceljs");
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ميزان المراجعة");

        const headers = Object.keys(exportData[0]);
        worksheet.addRow(headers);

        exportData.forEach((row) => {
          worksheet.addRow(Object.values(row));
        });

        // Add totals row
        const totalsRow = worksheet.addRow([
          "", "المجموع", "", "", "", "",
          this.sumPreviousRemaining,
          this.sumCurrentRawFee,
          "",
          this.sumPercentageDiscount,
          this.sumFixedDiscount,
          this.sumCurrentInstallment,
          this.sumCurrentPaid,
          this.sumCurrentRemaining,
          this.sumTotal,
        ]);
        totalsRow.font = { bold: true };
        totalsRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE8F5E9" },
        };

        worksheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
        worksheet.getRow(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF0E734B" },
        };

        worksheet.columns.forEach((column) => {
          column.width = 18;
        });
        worksheet.getColumn(1).width = 6;
        worksheet.getColumn(2).width = 30;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `trial_balance_report.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

        this.$toasted.success("تم تصدير البيانات بنجاح");
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.$toasted.error("حدث خطأ في تصدير البيانات");
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
